var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserProfile = function SvgUserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.105 14a.7.7 0 0 0-.221 0A2.99 2.99 0 0 1 9 11c0-1.663 1.337-3 3-3a3 3 0 0 1 3 3c-.012 1.628-1.29 2.954-2.895 3M6 20c0-1.663 2.674-3 6-3s6 1.349 6 3"
  })));
};
export default SvgUserProfile;